module.exports = __webpack_public_path__ + "img/18.3632fa56.png";